import { createAsyncThunk } from "@reduxjs/toolkit";
import { Axios } from "api/axios";

export interface fieldStock {
  id?: string;
  packageName: string;
  fieldStockCode: string;
  fieldStockName: string;
  state: string;
  status: boolean;
  createBy?: string;
  updatedBy?: string;
  createDate?: string;
  updateDate?: string;
}
export interface PaginatedResponse<T> {
  count: number;
  total_pages: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

// const API_URL = "/api/package";
// const API_URL = "https://mastersappbe.kdcstaging.in/api/package";
const API_URL = process.env.REACT_APP_BASE_URL;

export const fetchfieldStocks = createAsyncThunk(
  "fieldStock/fetchfieldStocks",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
  }) => {
    try {
      const params = new URLSearchParams();
      params.append("page", page.toString());
      params.append("page_size", pageSize.toString());
      if (search) params.append("search", search);
      if (sort) {
        const orderingValue = order === "desc" ? `-${sort}` : sort;
        params.append("ordering", orderingValue);
      }

      if (filters && filters.length > 0) {
        filters.forEach(
          ({
            filterField,
            filterValue,
          }: {
            filterField: string;
            filterValue: any;
          }) => {
            if (
              filterField &&
              filterValue !== undefined &&
              filterValue !== null
            ) {
              if (typeof filterValue === "object" && filterValue !== null) {
                // Handle cases like { from_date: ..., to_date: ... }
                Object.entries(filterValue).forEach(([key, value]) => {
                  if (value !== undefined && value !== null && value !== "") {
                    params.append(key, String(value));
                  }
                });
              } else {
                // Handle primitive values (string, number)
                params.append(filterField, filterValue);
              }
            }
          }
        );
      }

      const response: any = await Axios.get(
        `/fieldStock/?${params.toString()}`
      );

      return {
        data: response.data.data || [],
        rowCount: response.data.count || 0,
      };
    } catch (error: any) {
      console.error(
        "fetchPackages error:",
        error.response?.data || error.message
      );
      throw new Error("Failed to fetch fieldStocks");
    }
  }
);

export const fetchItems = createAsyncThunk(
  "fieldStock/fetchfieldStocks",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
  }) => {
    try {
      const params = new URLSearchParams();
      params.append("page", page.toString());
      params.append("page_size", pageSize.toString());
      if (search) params.append("search", search);
      if (sort) {
        const orderingValue = order === "desc" ? `-${sort}` : sort;
        params.append("ordering", orderingValue);
      }

      if (filters && filters.length > 0) {
        filters.forEach(
          ({
            filterField,
            filterValue,
          }: {
            filterField: string;
            filterValue: any;
          }) => {
            if (
              filterField &&
              filterValue !== undefined &&
              filterValue !== null
            ) {
              if (typeof filterValue === "object" && filterValue !== null) {
                // Handle cases like { from_date: ..., to_date: ... }
                Object.entries(filterValue).forEach(([key, value]) => {
                  if (value !== undefined && value !== null && value !== "") {
                    params.append(key, String(value));
                  }
                });
              } else {
                // Handle primitive values (string, number)
                params.append(filterField, filterValue);
              }
            }
          }
        );
      }

      const response: any = await Axios.get(
        `/fieldStock/?${params.toString()}`
      );

      return {
        data: response.data.data || [],
        rowCount: response.data.count || 0,
      };
    } catch (error: any) {
      console.error(
        "fetchPackages error:",
        error.response?.data || error.message
      );
      throw new Error("Failed to fetch fieldStocks");
    }
  }
);

export const fetchfieldStockById = createAsyncThunk(
  "fieldStock/fetchById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`${API_URL}/fieldStock/${id}/get/`);
      return response;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch fieldStock by ID"
      );
    }
  }
);

export const fetchfieldStocksBasedOnSelectedPackage = createAsyncThunk(
  "fieldStock/fetchById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await Axios.get(
        `${API_URL}/block/dropdown/fieldStocks/?package_id=${id}`
      );
      return response;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch fieldStock by ID"
      );
    }
  }
);

export const fetchfieldStockByDropDown = createAsyncThunk(
  "package/fetchByDropDown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`/fieldStock/dropdown/`);
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch fieldStock list"
      );
    }
  }
);

export const fetchSupervisorDropDown = createAsyncThunk(
  "package/fetchByDropDown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`/fieldStock/dropdown/`);
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch fieldStock list"
      );
    }
  }
);

export const fetchRingIds = createAsyncThunk(
  "package/fetchByDropDown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`/fieldStock/dropdown/`);
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch fieldStock list"
      );
    }
  }
);

export const fetchSpanIds = createAsyncThunk(
  "package/fetchByDropDown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`/fieldStock/dropdown/`);
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch fieldStock list"
      );
    }
  }
);

export const fetchGPs = createAsyncThunk(
  "package/fetchByDropDown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`/fieldStock/dropdown/`);
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch fieldStock list"
      );
    }
  }
);

export const fetchMaterials = createAsyncThunk(
  "package/fetchByDropDown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`/fieldStock/dropdown/`);
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch fieldStock list"
      );
    }
  }
);

export const fetchItemSKUs = createAsyncThunk(
  "package/fetchByDropDown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`/fieldStock/dropdown/`);
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch fieldStock list"
      );
    }
  }
);

export const fetchUnits = createAsyncThunk(
  "package/fetchByDropDown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`/fieldStock/dropdown/`);
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch fieldStock list"
      );
    }
  }
);

export const fetchCategories = createAsyncThunk(
  "package/fetchByDropDown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`/fieldStock/dropdown/`);
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch fieldStock list"
      );
    }
  }
);

export const fetchSubCategories = createAsyncThunk(
  "package/fetchByDropDown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`/fieldStock/dropdown/`);
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch fieldStock list"
      );
    }
  }
);

export const updatefieldStock = createAsyncThunk(
  "fieldStock/updatefieldStock",
  async (packageData: any) => {
    // const token = localStorage.getItem("authToken");
    // if (!token) {
    //   throw new Error("No authentication token found");
    // }
    const response: any = await Axios.put(
      `${API_URL}/fieldStock/${packageData.id}/update/`,
      packageData
    );
    return response;
  }
);

export const addfieldStock = createAsyncThunk(
  "fieldStock/addfieldStock",
  async (packageData: any) => {
    const response = await Axios.post(
      `${API_URL}/fieldStock/create/`,
      packageData
    );

    return response.data;
  }
);

export const exportfieldStockCSV = async () => {
  const response = await Axios.get("/fieldStock/?export=csv", {
    responseType: "blob",
  });

  return {
    blob: response.data,
    filename:
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") || "fieldStock.csv",
  };
};
